<template>
  <footer class="text-light main-footer">
    <div class="container-fluid">
      <b-row class="hidden-print">
        <b-col :cols="6" :sm="6" :md="3" :lg="2">
          <div class="widget">
            <h5 class="h5 text-uppercase">
              Products
            </h5>
            <b-nav class="d-block">
              <b-nav-item
                href="https://www.dripcapital.com/en-in/products/invoice-factoring"
              >
                Invoice Factoring
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/products/receivables-factoring"
              >
                Receivables Factoring
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/products/trade-finance"
              >
                Trade Finance
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/products/export-factoring"
              >
                Export Factoring
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/products/bill-discounting"
              >
                Bill Discounting
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/products/post-shipment-finance"
              >
                Post Shipment Finance
              </b-nav-item>
            </b-nav>
          </div>
        </b-col>
        <b-col :cols="6" :sm="6" :md="3" :lg="2">
          <div class="widget">
            <h5 class="h5 text-uppercase">Explore</h5>
            <b-nav class="d-block">
              <b-nav-item href="https://www.dripcapital.com/en-in/exporters">
                Exporters
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/invest-in-trade-receivables"
              >
                Investors
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/channel-partner"
              >
                Partner With Us
              </b-nav-item>

              <b-nav-item :to="{ name: 'listing' }">
                HSN Code Finder
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/resources/finance-guides"
              >
                Finance Guides
              </b-nav-item>

              <b-nav-item
                href="https://www.dripcapital.com/en-in/resources/blog"
              >
                Blog
              </b-nav-item>
            </b-nav>
          </div>
        </b-col>
        <b-col :cols="6" :sm="6" :md="3" :lg="2">
          <div class="widget">
            <h5 class="h5 text-uppercase">Help</h5>
            <b-nav class="d-block">
              <!-- <b-nav-item href="https://www.dripcapital.com/support/en/">
                FAQs
              </b-nav-item> -->
              <b-nav-item
                href="https://www.dripcapital.com/en-in/interest-calculator"
              >
                Interest Calculator
              </b-nav-item>
            </b-nav>
          </div>
        </b-col>
        <b-col :cols="6" :sm="6" :md="3" :lg="2">
          <div class="widget">
            <h5 class="h5 text-uppercase">Company</h5>
            <ul class="list-unstyled">
              <b-nav-item href="https://www.dripcapital.com/en-in/about">
                About Us
              </b-nav-item>
              <b-nav-item href="https://www.dripcapital.com/en-in/contact">
                Contact
              </b-nav-item>
              <b-nav-item href="https://www.dripcapital.com/en-in/leadership">
                Leadership Team
              </b-nav-item>
              <b-nav-item href="https://www.dripcapital.com/en-in/careers">
                Careers
              </b-nav-item>
            </ul>
          </div>
        </b-col>
        <b-col :cols="12" :lg="4">
          <b-img-lazy
            class="drip-logo"
            alt="Logo"
            title="Drip"
            :src="require(`../assets/images/drip-logo-white-tagline-e2e.svg`)"
            :width="180"
          />
          <br /><br />
          <div class="row">
            <div class="col-6">
              <span class="badge badge-primary text-upper">USA</span>
              <p>
                Drip Capital Inc.<br />
                555 Bryant St. #356,<br />
                Palo Alto, CA 94301<br /><br />
                <a class="text-primary" href="tel:+1-844-804-4822"
                  >+1-844-804-4822</a
                >
              </p>
            </div>
            <div class="col-6">
              <span class="badge badge-primary text-upper">India</span>
              <p>
                Drip Capital Services India LLP<br />
                1221, 2nd Floor, Building 12 Solitaire Corporate Park,<br />
                Guru Hargovindji Rd, Chakala, Andheri East, Mumbai, Maharashtra
                400093<br /><br />
                <a class="text-primary" href="tel:+91-9987-779-334"
                  >+91-9987-779-334</a
                >
              </p>
            </div>
          </div>
        </b-col>
        <b-col :cols="12" :sm="12" :md="6" :lg="4" class="footline">
          <br />
          <p class="custom-copyright-text">
            &copy; {{ currentYear }} Drip Capital Inc. USA
          </p>
          <b-nav class="d-flex footer-privacy-menu">
            <b-nav-item
              class="list-inline-item"
              href="https://www.dripcapital.com/en-in/terms-of-use"
            >
              Terms of Use
            </b-nav-item>
            <b-nav-item
              class="list-inline-item"
              href="https://www.dripcapital.com/en-in/privacy-policy"
            >
              Privacy Policy
            </b-nav-item>
            <b-nav-item
              class="list-inline-item"
              href="https://share.hsforms.com/2cEr9Y2UYQDOE1NbYW_PX6Qcwe7e"
            >
              Opt-out
            </b-nav-item>
          </b-nav>
        </b-col>
        <b-col :cols="12" :sm="12" :md="6" :lg="4" class="footline">
          <a href="https://fci.nl/en/home" target="_blank">
            <b-img-lazy
              :height="40"
              class="footer-image fci"
              alt="FCI"
              title="Drip Capital Inc. is member of Factors Chain International"
              :src="require(`../assets/images/fci-union-logo.png`)"
            />
          </a>
          <b-img-lazy
            :height="35"
            class="footer-image ssl"
            alt="SSL Secured"
            title="The connection to this site is encrypted and authenticated using a strong protocol (TLS 1.2), a strong key exchange (ECDHE_RSA with P-256), and a strong cipher (AES_128_GCM)."
            :src="require(`../assets/images/ssl.png`)"
          />
        </b-col>
      </b-row>
      <br />
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    currentYear() {
      const now = new Date()
      return now.getFullYear()
    }
  }
}
</script>

<style>
.custom-copyright-text {
  padding-top: 1rem;
  margin-bottom: 0;
}
</style>
